import type { EntryMeta } from '~/types'
import Gallery from '~/components/gallery/Gallery'
import type { MediaPath } from '~/generated/media'

const cover = 'thailand/IMG_20191120_183320.jpg' satisfies MediaPath
const a = 'thailand/IMG_20191109_181708.jpg' satisfies MediaPath
const b = 'thailand/IMG_20191111_203937.jpg' satisfies MediaPath
const c = 'thailand/IMG_20191112_173625.jpg' satisfies MediaPath
const d = 'thailand/IMG_20191115_142138.jpg' satisfies MediaPath
const e = 'thailand/IMG_20191116_074810.jpg' satisfies MediaPath

export const meta: EntryMeta = {
	slug: '2019',
	name: '2019',
	excerpt: 'The long year',
	tags: ['photography'],
	cover,
	featured: true,
	order: 120,
}

export default function Year2019() {
	return (
		<>
			<p>A year in frames.</p>
			<Gallery
				items={[
					{ src: cover, alt: '2019 — winter dusk' },
					{ src: a, alt: '2019' },
					{ src: b, alt: '2019' },
					{ src: c, alt: '2019' },
					{ src: d, alt: '2019' },
					{ src: e, alt: '2019' },
				]}
			/>
		</>
	)
}
